import { queryOptions, useQuery } from "@tanstack/react-query";

import data from "../../assets/mocks/market-car-images.json";

import { api } from "@/lib/api-client";
import { hasAccessToken } from "@/lib/auth";
import { AxiosMock } from "@/utils/mock";

import type { QueryConfig } from "@/lib/react-query";
import type { Attachment } from "@/types/attachment";
import type { List } from "@/types/entity";

if (import.meta.env.MODE === "test") {
  // Mocking the API response for market car images
  const mock = AxiosMock.getInstance();
  const uri = new RegExp("/carburate/market/cars/.+/images/?$");
  mock.onGet(uri).reply(200, data);
}

export const getMarketCarImages = async (carId?: string) => {
  return api.get(`/carburate/market/cars/${carId}/images/`) as Promise<List<Attachment>>;
};

export const getMarketCarImagesQueryOptions = ({ carId }: { carId?: string }) => {
  return queryOptions({
    queryKey: ["market", "cars", carId, "images"],
    queryFn: () => getMarketCarImages(carId),
  });
};

type UseMarketCarImagesOptions = {
  carId?: string;
  queryConfig?: QueryConfig<typeof getMarketCarImages>;
};

export const useMarketCarImages = ({ carId, queryConfig }: UseMarketCarImagesOptions) => {
  return useQuery({
    enabled: hasAccessToken() && !!carId,
    ...getMarketCarImagesQueryOptions({ carId }),
    ...queryConfig,
  });
};
